import { AxiosResponse } from 'axios';
import { axiosInstance } from '@fides/fides-react-components';
import { endpoints } from 'core/consts';

export type StructuredRemittanceInfoPage = {
  content?: any[];
  totalElements?: number;
};

type NumberRangeFilter = {
  lowerBound?: number;
  upperBound?: number;
};

export type StructuredRemittanceInfoFilter = {
  reference?: string;
  documentNumber?: string;
  documentType?: string[];
  globalSearch?: string;
  additionalRemittanceInfo?: string;
  documentRelatedDateRange?: {
    lowerBound?: string;
    upperBound?: string;
  };
  remittedAmount?: NumberRangeFilter;
  remittedAmountCurrency?: string[];
  duePayableAmount?: NumberRangeFilter;
  duePayableCurrency?: string[];
  discountAppliedAmount?: NumberRangeFilter;
  discountAppliedCurrency?: string[];
  creditNoteAmount?: NumberRangeFilter;
  creditNoteCurrency?: string[];
  taxAmount?: NumberRangeFilter;
  taxAmountCurrency?: string[];
  orderIndex?: number;
};

export type StructuredRemittanceInfoQuery = {
  size: number;
  page: number;
  sort?: string[];
  filter?: StructuredRemittanceInfoFilter;
};

export const getStructuredRemittanceInfos = (
  transactionUUID: string,
  query: StructuredRemittanceInfoQuery
): Promise<AxiosResponse<StructuredRemittanceInfoPage>> => {
  const url = `${endpoints.EFTApiUrl}/transactions/${transactionUUID}/${endpoints.structuredRemittanceInfos}`;
  return axiosInstance.get(url, {
    baseURL: undefined,
    params: query,
  });
};
